import { render } from "./PendingPackage.vue?vue&type=template&id=db600e66"
import script from "./PendingPackage.vue?vue&type=script&lang=js"
export * from "./PendingPackage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__